var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"estimated-run-time"},[_c('v-icon',{attrs:{"color":"grey darken-2","small":""}},[_vm._v("mdi-clock-outline")]),_c('span',{staticClass:"run-time-text"},[_vm._v("estimated run time: "+_vm._s(_vm.estimatedRunTime || 'unmeasured'))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }